import Vue from 'vue'
import App from './App.vue'
import router from "./router.js"
import VueI18n from 'vue-i18n'

import {
  BootstrapVue,
  IconsPlugin
} from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../public/assets/css/styles.css';

// Import locale files
import en from './locales/en.json'
import lv from './locales/lv.json'

Vue.config.productionTip = false

// Configure i18n
Vue.use(VueI18n)

// Determine initial language based on current path and saved preference
function getInitialLanguage() {
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage) {
    return savedLanguage;
  }
  
  // Check if current path is /en
  if (window.location.pathname === '/en') {
    return 'en';
  }
  
  // Default to Latvian
  return 'lv';
}

const i18n = new VueI18n({
  locale: getInitialLanguage(),
  fallbackLocale: 'lv',
  messages: {
    en,
    lv
  }
})

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')